import React from 'react'
import PropTypes from 'prop-types'
import { BqTag } from '@beeq/react/src'
import { removedValueObj } from '../../utils/utils'

export default function AppliedFiltersTags ({
  filterData,
  setFilterData,
  handleAdvancedSearch
}) {
  const onClickRemovableHandler = (value, name) => {
    const newObject = removedValueObj(value, name, filterData)
    setFilterData?.(newObject)
    handleAdvancedSearch?.(newObject)
  }

  return Object.keys(filterData).map((elem, index) => {
    return (
      <React.Fragment key={index}>
          {
          elem !== 'completion' && typeof filterData[elem] === 'object'
            ? filterData[elem].map((item) => {
              return (
              <BqTag removable key={`${elem}${item}`} onBqClose={(e) => {
                e.stopImmediatePropagation()
                onClickRemovableHandler(e.target.textContent, elem)
              }}
                data-testid={`advanced-search-filter-${elem}-${item}-tag`}
              >
                {item}
              </BqTag>)
            })
            : <React.Fragment key={elem}></React.Fragment>}
      </React.Fragment>)
  })
}

AppliedFiltersTags.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func,
  handleAdvancedSearch: PropTypes.func
}
